import React from 'react'
import PropTypes from 'prop-types'
import '../assets/css/components/heredity-probability-answer-row.css'

const HeredityProbabilityAnswerRow = props => {
  const { question, givenAnswer, denominator, isCorrect } = props

  return(
    <div className='heredity-probability-answer-row'>
      <div className={`text-container ${isCorrect ? 'correct' : 'incorrect'}`}>
        <span className='question'><span className='text'>{question}</span></span>
        <span className='given-answer'><span className='text'>{givenAnswer}</span></span>
        <span className='chance-text'>in {denominator} chance</span>
      </div>
    </div>
  )
}

HeredityProbabilityAnswerRow.propTypes = {
  question:     PropTypes.string.isRequired,
  givenAnswer:  PropTypes.number.isRequired,
  denominator:  PropTypes.number.isRequired,
  isCorrect:    PropTypes.bool
}

HeredityProbabilityAnswerRow.defaultProps = {
  isCorrect: true
}

export default HeredityProbabilityAnswerRow
